export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_LANGUAGE_LOADING = 'SET_LANGUAGE_LOADING';
export const SET_LANGUAGE_INITIALIZED = 'SET_LANGUAGE_INITIALIZED';
